import React from "react";
import { Loader2, ShieldCheck } from "lucide-react";

import { useSaveConsents } from "../../hooks/queries/useAthletes";

/**
 * The athlete's switch for sharing their daily check-in (wellness, load,
 * meals) with the coaches of the academy that confirmed them. Without it a
 * coach's report shows performance and availability only. Stored under
 * attributes.consents.academy_data_sharing — the backend reads exactly that.
 */
const AcademySharingSetting = ({ athleteId, attributes }) => {
  const save = useSaveConsents();
  const granted = attributes?.consents?.academy_data_sharing?.granted === true;
  const pending = save.isPending;
  const shown = pending ? save.variables?.consents?.academy_data_sharing?.granted : granted;

  const toggle = () =>
    save.mutate({
      athleteId,
      consents: { academy_data_sharing: { granted: !granted, updated_at: new Date().toISOString() } },
    });

  return (
    <div className="flex items-start justify-between gap-4 rounded-lg p-3">
      <div className="flex items-start gap-3">
        <div className="rounded-lg bg-green-100 p-2 text-green-700">
          <ShieldCheck size={18} aria-hidden="true" />
        </div>
        <div>
          <p id="academy-sharing-label" className="text-sm font-bold text-gray-900">
            Compartir mi check-in con mi academia
          </p>
          <p className="text-xs text-gray-500">
            Tus entrenadores verán tu estado, bienestar, carga y comidas en sus reportes. Si lo desactivas, solo verán tu
            rendimiento. Puedes cambiarlo cuando quieras.
          </p>
          {save.isError && (
            <p role="alert" className="mt-1 text-xs text-red-600">
              {save.error.message}
            </p>
          )}
        </div>
      </div>
      <button
        type="button"
        role="switch"
        aria-checked={Boolean(shown)}
        aria-labelledby="academy-sharing-label"
        onClick={toggle}
        disabled={pending || !athleteId}
        className={`relative mt-1 inline-flex h-6 w-11 shrink-0 items-center rounded-full transition-colors disabled:opacity-60 ${
          shown ? "bg-blue-900" : "bg-gray-300"
        }`}
      >
        <span
          className={`inline-block h-5 w-5 transform rounded-full bg-white shadow transition-transform ${
            shown ? "translate-x-5" : "translate-x-0.5"
          }`}
        />
        {pending && <Loader2 size={12} className="absolute -right-5 animate-spin text-blue-900" aria-hidden="true" />}
      </button>
    </div>
  );
};

export default AcademySharingSetting;
